<div class="flex-column f-1-0">
	<ng-container *ngFor="let condition of conditionArr; let first = first; let orIndex = index">
		<span class="fw-bold opacity-75" style="color: #486db5; margin: 8px 5px;" *ngIf="!first">OR</span>
		<ng-container *ngTemplateOutlet="conditionHtml; context: {$implicit: condition, orIndex}"></ng-container>
	</ng-container>
</div>

<ng-template #conditionHtml let-condition let-orIndex="orIndex">
	<div class="flex-row gap-4 align-items-center f-1-0 animated fadeIn" [style.z-index]="80 - orIndex">
		<!--Select condition type-->
		<app-dropdown-c style="width: 250px;"
						[items]="conditionTypes"
						(onItemClicked)="changeConditionType(condition, $event.item.name);"
						[text]="rulesOptions.types[condition.type].label"
						[error]="condition.invalidConditionType"
						itemDisplayKey="label">
		</app-dropdown-c>

		<div class="animated fadeIn flex-row gap-4 align-items-center f-1-0" style="z-index: 40;"
			 *ngIf="condition.type === rulesOptions.types.incident_combination.name">
			<span>of types</span>

			<!--incident types dropdown-->
			<app-dropdown-c style="width: 340px;"
							[items]="condition.data.incidentTypes"
							(onItemClicked)="condition.invalidIncidentTypes = false; condition.data.selectedIncidentType = $event.item;"
							[isMultipleSelection]="true"
							itemDisplayKey="name"
							[error]="condition.invalidIncidentType || condition.invalidIncidentTypes">
			</app-dropdown-c>

			<div class="flex-row align-items-center gap-3 text-nowrap">
				<span>occurs</span>
				<span style="margin-left: -10px;">within</span>
				<input type="number" style="width: 45px;" min="1"
					   [(ngModel)]="condition.data.hours"
					   [ngClass]="{'validation-error' : condition.invalidIncidentHoursSpan}">
				<span>hours</span>
			</div>
		</div>

		<div class="animated fadeIn flex-row gap-4 align-items-center f-1-0" style="z-index: 40;"
			 *ngIf="condition.type === rulesOptions.types.incident_frequency.name">
			<span>of type</span>

			<!--incident types dropdown-->
			<app-dropdown-c style="width: 340px;"
							[items]="condition.data.incidentTypes"
							(onItemClicked)="condition.invalidIncidentTypes = false; condition.data.selectedIncidentType = $event.item;"
							itemDisplayKey="name"
							[text]="condition.data.selectedIncidentType?.name"
							[error]="condition.invalidIncidentType || condition.invalidIncidentTypes">
			</app-dropdown-c>

			<div class="flex-row align-items-center gap-3 text-nowrap">
				<span>occurs</span>
				<ng-container>
					<input type="number" style="width: 45px;" min="1"
						   [(ngModel)]="condition.data.incidentCount"
						   [ngClass]="{'validation-error' : condition.invalidIncidentCount}">
					<span>times </span>
				</ng-container>
				<span style="margin-left: -10px;">within</span>
				<input type="number" style="width: 45px;" min="1"
					   [(ngModel)]="condition.data.hours"
					   [ngClass]="{'validation-error' : condition.invalidIncidentHoursSpan}">
				<span>hours</span>
			</div>
		</div>

		<div class="animated fadeIn flex-row gap-4 align-items-center" style="z-index: 40;"
			 *ngIf="condition.type === rulesOptions.types.target_users.name">
			<span>are</span>
			<app-dropdown-c style="width: 340px;"
							[enableSearch]="true"
							[items]="condition.data.users"
							(onItemClicked)="condition.invalidIncidentUsers = false;"
							[isMultipleSelection]="true"
							itemDisplayKey="email"
							[error]="condition.invalidIncidentUsers">
			</app-dropdown-c>
		</div>

		<div class="animated fadeIn flex-row gap-4 align-items-center" style="z-index: 40;"
			 *ngIf="condition.type === rulesOptions.types.user_status.name">
			<span>is</span>
			<app-dropdown-c style="width: 150px;"
							text="{{condition.data.status || 'Select'}}">
				<ul>
					<li *ngFor="let matchTypeVal of ['Active', 'Risky', 'Blocked']"
						(click)="condition.data.status = matchTypeVal;">
					<span>
						{{matchTypeVal}}
					</span>
					</li>
				</ul>
			</app-dropdown-c>
		</div>

		<i class="zmdi zmdi-close text-danger hvr-darken cursor-pointer px-3 py-2 animated fadeIn" tooltip="Remove condition"
		   *ngIf="(condition.isException ? true : newRule.conditions.length > 1) || conditionArr.length > 1"
		   (click)="cancelNewRuleCondition(orIndex, conditionIndex)"></i>
	</div>
</ng-template>
